<template>
  <div class="login-error">
    <h1>Invalid Details</h1>
  </div>
</template>

<script>
  export default {
    name: 'LoginError',
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Auth/LoginError.vue